import React, { FC } from "react";
import { ContentLibraryModel } from "../../../../../../models/ContentLibraryModel/contentLibrary.model";
import pdfIcon from "../../../../../../assets/icons/pdf-chapter-icon.svg";
import videoIcon from "../../../../../../assets/icons/video-chapter-icon.svg";
import "./referenceContentList.scss";
import menuIcon from "../../../../../../assets/icons/menu-icon.svg";
import { Dropdown, Menu } from "antd";
interface ReferenceContentListProps {
  contents: ContentLibraryModel[];
  onRemove: (index: number) => void
}
const ReferenceContentList = ({ contents, onRemove }: ReferenceContentListProps) => {
  return (
    <div>
      {contents.map((content: any, i: number) => (
        <div key={i}>
          <div className="reference-content__card">
            <div className="add-content__card__image">
              <img src={content?.displayPictureUrl} alt="" />
            </div>
            <div className="add-content__info">
              <div className="add-content__title">{content?.title}</div>
              <div className="add-content__detail">
                <img
                  src={content?.contentType === "pdf" ? pdfIcon : videoIcon}
                  alt=""
                />
                {content?.contentLength}{" "}
                {content?.contentType === "pdf" ? " pages" : " mins"}
              </div>
            </div>
            <div className="reference-content__menu">
              <Dropdown
                overlay={
                  <Menu className="courses__card__menu">
                    <Menu.Item
                      key="edit"
                      onClick={() => {
                        onRemove(i)
                      }}
                    >
                      Remove
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click"]}
                placement={"bottomRight"}
                className="course__dropdown"
              >
                <img src={menuIcon} alt="" />
              </Dropdown>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
export default ReferenceContentList;
